var map = {
	"./bash.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/bash.txt",
	"./css.css": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/css.css",
	"./diff.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/diff.txt",
	"./handlebars.hbs": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/handlebars.hbs",
	"./html.html": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/html.html",
	"./js": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/js.js",
	"./js.js": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/js.js",
	"./json.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/json.txt",
	"./jsx": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/jsx.jsx",
	"./jsx.jsx": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/jsx.jsx",
	"./php.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/php.txt",
	"./scss.scss": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/scss.scss",
	"./toml.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/toml.txt",
	"./tsx": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/tsx.tsx",
	"./tsx.tsx": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/tsx.tsx",
	"./twig.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/twig.txt",
	"./typescript": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/typescript.ts",
	"./typescript.ts": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/typescript.ts",
	"./yaml.txt": "./node_modules/raw-loader/dist/cjs.js!./src/vendor/highlight/demo/samples/yaml.txt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/vendor/highlight/demo/samples sync ./!./!./node_modules/raw-loader/dist/cjs.js!./ ^\\.\\/.*$";